export default __webpack_public_path__ + "static/media/phase3-line.8c1d33a5.svg";